import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Snackbar from "./Snackbar";
import { closeSnackbar } from "../actions/globalSnackbarActions";
import { IconCopy } from "@tabler/icons-react";

const CopyPasswordButton = ({ password }) => {
	const [copied, setCopied] = useState(false);
	return (
		<span
			onClick={() => {
				navigator.clipboard.writeText(password);
				setCopied(true);
				setTimeout(() => setCopied(false), 2000);
			}}
			style={{
				cursor: "pointer",
				whiteSpace: "nowrap",
				display: "inline-flex",
				alignItems: "center",
				gap: 4,
			}}
		>
			<IconCopy size={13} />
			{copied ? "Copied!" : "Copy share password"}
		</span>
	);
};

const buildSnackbarMessage = (snackbar) => {
	const { message, sharePassword, shareID } = snackbar;
	if (!sharePassword && !shareID) return message;
	return (
		<span style={{ display: "flex", flexDirection: "column", gap: 6 }}>
			<span>{message}</span>
			<span style={{ display: "flex", gap: 16 }}>
				{sharePassword && (
					<CopyPasswordButton password={sharePassword} />
				)}
				{shareID && (
					<Link
						to={`/sharing/outgoing/${shareID}`}
						style={{ color: "inherit", whiteSpace: "nowrap" }}
					>
						View share details
					</Link>
				)}
			</span>
		</span>
	);
};

class GlobalSnackbar extends Component {
	render() {
		return Object.keys(this.props.snackbars).length
			? Object.keys(this.props.snackbars).map((snackbarKey, index) => {
					const {
						open,
						message,
						variant,
						autoHideDuration,
						loadingSpinnerVisible,
						allowClose,
						disableWindowBlurListener,
						sharePassword,
						shareID,
					} = this.props.snackbars[snackbarKey];
					return (
						<Snackbar
							key={snackbarKey}
							onClose={() =>
								this.props.closeSnackbar({ snackbarKey })
							}
							open={open}
							message={buildSnackbarMessage({
								message,
								sharePassword,
								shareID,
							})}
							variant={variant}
							autoHideDuration={autoHideDuration}
							loadingSpinnerVisible={loadingSpinnerVisible}
							allowClose={allowClose}
							disableWindowBlurListener={
								disableWindowBlurListener
							}
							snackbarKey={snackbarKey}
							stackIndex={index}
						/>
					);
				})
			: null;
	}
}
const mapStateToProps = (state) => ({
	snackbars: state.snackbar,
});
export default connect(mapStateToProps, { closeSnackbar })(GlobalSnackbar);
